/**
 * define the extensions accepted during an upload
 */
const img = [
    '.png',
    '.jpg',
    '.jpeg',
    '.bmp',
    '.tif',
    '.tiff',
    '.webp'
];

const doc = [
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.pdf',
    '.rtf',
    '.csv',
    '.ppt',
    '.pptx',
];

export const extensions = {
    rh: [
        '.csv'
    ],
    img: [
        ...img
    ],
    help_contact: [
        ...img,
        ...doc
    ],
    doc: [
        ...doc
    ],
    all: [
        ...doc,
        ...img,
        '.7z',
        '.zip',
        '.rar',
        '.msg',
        '.ext',
        '.htm',
        '.html',
        '.mht',
        '.odt',
        '.txt',
        '.xps',
        '.eml',
        '.webarchives',
        '.psd',
        '.log',
        '.logs',
    ]
};
